export default __webpack_public_path__ + "static/media/FOTOS_DISCO_10.bbf23d44.jpg";